// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__ukN_4","graphics":"styles_graphics__mzuzC"};